// @flow
import React from 'react';
import styled from 'styled-components';
import { Small } from '@finect/tabular-core/Small';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { getFont } from '@finect/tabular-utils/getFont';

const Blockquote = styled.blockquote`
  position: relative;
  padding: ${({ right }) => (right ? '12px 30px 27px 0' : '0 0 27px 30px')};
  margin: 0;
  ${getFont(0)};
  text-align: ${({ right }) => (right ? 'right' : 'left')};

  &:before,
  &:after {
    position: absolute;
    bottom: 0;
    left: ${({ right }) => (right ? 'auto' : '0')};
    right: ${({ right }) => (right ? '0' : 'auto')};
    border-radius: 4px;
    content: '';
  }

  &:before {
    height: 60px;
    border-left: 4px solid ${({ theme }) => theme.secondaryColor};
  }

  &:after {
    width: 60px;
    border-bottom: 4px solid ${({ theme }) => theme.secondaryColor};
  }

  ${maxMediaQueries.phablet`
    padding: 27px 30px;
    text-align: left;

    &:before,
    &:after {
      left: 0;
      right: auto;
    }
  `};
`;

const Square = styled.div`
  ${maxMediaQueries.phablet`
    &:before,
    &:after {
      position: absolute;
      top: 0;
      right: 0;
      border-radius: 4px;
      content: '';
    }

    &:before {
      height: 60px;
      border-right: 4px solid ${({ theme }) => theme.secondaryColor};
    }

    &:after {
      width: 60px;
      border-bottom: 4px solid ${({ theme }) => theme.secondaryColor};
    }
  `};
`;

const Author = styled.div`
  padding-top: 9px;
`;

type Props = {
  author?: string,
  right?: boolean,
  children: any
};

export const SideBlockquote = ({ author, right, children }: Props) => (
  <Blockquote right={right}>
    <Square right={right} />
    {children}
    {author ? (
      <Author>
        <Small light>{author}</Small>
      </Author>
    ) : null}
  </Blockquote>
);
